export interface State {
  projects: any[];
  currentProject?: any;
  navbarActions?: any[];
  pending?: boolean;
  error?: string | null;
}

export const initialState: State = {
  projects: [],
  currentProject: null,
  navbarActions: [],
  pending: false,
  error: null,
};
